"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERoles = exports.ParseUser = exports.ParseFile = exports.ParseGeoPoint = exports.ParseACL = void 0;
const local_parse_1 = require("../local-parse");
class ParseACL extends local_parse_1.Parse.ACL {}
exports.ParseACL = ParseACL;
;
class ParseGeoPoint extends local_parse_1.Parse.GeoPoint {}
exports.ParseGeoPoint = ParseGeoPoint;
;
class ParseFile extends local_parse_1.Parse.File {}
exports.ParseFile = ParseFile;
;
class ParseUser extends local_parse_1.Parse.User {}
exports.ParseUser = ParseUser;
;
var ERoles = /*#__PURE__*/function (ERoles) {
  ERoles["Admin"] = "Admin";
  ERoles["Pharmacy"] = "Pharmacy";
  ERoles["Customer"] = "Customer";
  return ERoles;
}(ERoles || (exports.ERoles = ERoles = {}));

